import { createStore, applyMiddleware, combineReducers} from "redux";
import AuthReducer from './ducks/auth'
import UserReducer from './ducks/user'
import OrgReducer from './ducks/organization'
import ProviderReducer from './ducks/provider'
import AiVerificationCallReducer from './ducks/aiVerificationCall'
import createSagaMiddleware from "redux-saga";
import { watcherSaga } from "./sagas/rootSaga";
import {composeWithDevTools} from 'redux-devtools-extension'

export const DESTROY_REDUX_SESSION = "DESTROY_REDUX_SESSION"

export const destroySession = payload => ({
  type: DESTROY_REDUX_SESSION,
  payload
})

const appReducer = combineReducers({
    auth: AuthReducer,
    provider: ProviderReducer,
    user: UserReducer,
    organization: OrgReducer,
    aiVerificationCall: AiVerificationCallReducer
  });


  const rootReducer = (state, action) => {
    if(action.type === DESTROY_REDUX_SESSION)
    {
      state = undefined;
    }
    return appReducer(state, action);
  }


const sagaMiddleware = createSagaMiddleware();

const middleware = [sagaMiddleware]

const store =
createStore(
  rootReducer,
  {},
  composeWithDevTools(applyMiddleware(...middleware))
);

sagaMiddleware.run(watcherSaga);

export default store;

